export default "__VITE_ASSET__DWxJ8GYa__"